import { Component } from '@angular/core';
import {GuestComponent} from "../../../layout/guest/guest.component";
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-register-success',
  imports: [
    GuestComponent,
    RouterLink
  ],
  templateUrl: './register-success.component.html',
  styleUrl: './register-success.component.scss'
})
export class RegisterSuccessComponent {

}
